const API_URL = process.env.REACT_APP_API_URL || 'http://localhost:8000';

// Error HTTP con status y data, para distinguir "sin internet" (sin status) de "el servidor rechazó los datos".
const buildHttpError = async (response, fallbackMessage) => {
    let data = null;
    try { data = await response.json(); } catch (e) { data = null; }
    const detail = data && (data.detail || JSON.stringify(data));
    const error = new Error(detail || `${fallbackMessage} (HTTP ${response.status})`);
    error.status = response.status;
    error.data = data;
    return error;
};
export const fetchPacientes = async () => {
    try {
        const token = localStorage.getItem('token');
        const response = await fetch(`${API_URL}/api/patients/`, {
            headers: {
                'Authorization': `Bearer ${token}`
            }
        });
        if (!response.ok) throw new Error('Error al cargar pacientes');
        const data = await response.json();
        // Django REST Framework with pagination returns { count, next, previous, results: [...] }
        return data.results !== undefined ? data.results : data;
    } catch (error) {
        console.error(error);
        return [];
    }
};

export const createPaciente = async (data) => {
    try {
        const token = localStorage.getItem('token');
        const response = await fetch(`${API_URL}/api/patients/`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${token}`
            },
            body: JSON.stringify(data),
        });
        if (!response.ok) throw await buildHttpError(response, 'Error al crear paciente');
        return await response.json();
    } catch (error) {
        console.error(error);
        throw error;
    }
};

export const createClinicalRecord = async (data) => {
    try {
        const token = localStorage.getItem('token');
        const response = await fetch(`${API_URL}/api/clinical-records/`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${token}`
            },
            body: JSON.stringify(data),
        });
        if (!response.ok) throw await buildHttpError(response, 'Error al crear historial clínico');
        return await response.json();
    } catch (error) {
        console.error(error);
        throw error;
    }
};
export const updatePaciente = async (id, data) => {
    try {
        const token = localStorage.getItem('token');
        const response = await fetch(`${API_URL}/api/patients/${id}/`, {
            method: 'PUT',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${token}`
            },
            body: JSON.stringify(data),
        });
        if (!response.ok) throw await buildHttpError(response, 'Error al actualizar paciente');
        return await response.json();
    } catch (error) {
        console.error(error);
        throw error;
    }
};

export const deletePaciente = async (id) => {
    try {
        const token = localStorage.getItem('token');
        const response = await fetch(`${API_URL}/api/patients/${id}/`, {
            method: 'DELETE',
            headers: {
                'Authorization': `Bearer ${token}`
            }
        });
        if (!response.ok) throw new Error('Error al eliminar paciente');
        return true;
    } catch (error) {
        console.error(error);
        throw error;
    }
};

export const fetchClinicalRecords = async (patientId) => {
    try {
        const token = localStorage.getItem('token');
        const response = await fetch(`${API_URL}/api/clinical-records/?patient=${patientId}&_t=${new Date().getTime()}`, {
            headers: {
                'Authorization': `Bearer ${token}`
            },
            cache: 'no-store'
        });
        if (!response.ok) throw new Error('Error al cargar historiales');
        const data = await response.json();
        let records = data.results !== undefined ? data.results : data;
        if (Array.isArray(records)) {
            records = records.filter(r => String(r.patient) === String(patientId) || (r.patient && String(r.patient.id) === String(patientId)));
        }
        return records;
    } catch (error) {
        console.error(error);
        return [];
    }
};

export const updateClinicalRecord = async (id, data) => {
    try {
        const token = localStorage.getItem('token');
        const response = await fetch(`${API_URL}/api/clinical-records/${id}/`, {
            method: 'PATCH',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${token}`
            },
            body: JSON.stringify(data),
        });
        if (!response.ok) throw await buildHttpError(response, 'Error al actualizar historial clínico');
        return await response.json();
    } catch (error) {
        console.error(error);
        throw error;
    }
};

export const getCieCodes = async () => {
    try {
        const token = localStorage.getItem('token');
        const response = await fetch(`${API_URL}/api/clinical-records/cie-codes/?limit=1000`, {
            headers: {
                'Authorization': `Bearer ${token}`
            }
        });
        if (!response.ok) throw new Error('Error al cargar códigos CIE');
        const data = await response.json();
        return data.results !== undefined ? data.results : data;
    } catch (error) {
        console.error(error);
        return [];
    }
};

export const createCieCode = async (data) => {
    try {
        const token = localStorage.getItem('token');
        const response = await fetch(`${API_URL}/api/clinical-records/cie-codes/`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${token}`
            },
            body: JSON.stringify(data),
        });
        if (!response.ok) throw new Error('Error al crear código CIE');
        return await response.json();
    } catch (error) {
        console.error(error);
        throw error;
    }
};

export const updateCieCode = async (code, data) => {
    try {
        const token = localStorage.getItem('token');
        const response = await fetch(`${API_URL}/api/clinical-records/cie-codes/${code}/`, {
            method: 'PUT',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${token}`
            },
            body: JSON.stringify(data),
        });
        if (!response.ok) throw new Error('Error al actualizar código CIE');
        return await response.json();
    } catch (error) {
        console.error(error);
        throw error;
    }
};

export const deleteCieCode = async (code) => {
    try {
        const token = localStorage.getItem('token');
        const response = await fetch(`${API_URL}/api/clinical-records/cie-codes/${code}/`, {
            method: 'DELETE',
            headers: {
                'Authorization': `Bearer ${token}`
            }
        });
        if (!response.ok) throw new Error('Error al eliminar código CIE');
        return true;
    } catch (error) {
        console.error(error);
        throw error;
    }
};

export const getConsentGraphics = async () => {
    try {
        const token = localStorage.getItem('token');
        const response = await fetch(`${API_URL}/api/clinical-records/consent-graphics/`, {
            headers: { 'Authorization': `Bearer ${token}` }
        });
        if (!response.ok) throw new Error('Error al cargar gráficos de consentimiento');
        const data = await response.json();
        return data.results !== undefined ? data.results : data;
    } catch (error) {
        console.error(error);
        return [];
    }
};

export const createConsentGraphic = async (formData) => {
    try {
        const token = localStorage.getItem('token');
        const response = await fetch(`${API_URL}/api/clinical-records/consent-graphics/`, {
            method: 'POST',
            headers: {
                'Authorization': `Bearer ${token}`
            },
            body: formData,
        });
        if (!response.ok) {
            const err = await response.json();
            throw new Error(err.detail || JSON.stringify(err) || 'Error al crear gráfico');
        }
        return await response.json();
    } catch (error) {
        console.error(error);
        throw error;
    }
};

export const updateConsentGraphicStatus = async (id, is_active) => {
    try {
        const token = localStorage.getItem('token');
        const response = await fetch(`${API_URL}/api/clinical-records/consent-graphics/${id}/`, {
            method: 'PATCH',
            headers: {
                'Authorization': `Bearer ${token}`,
                'Content-Type': 'application/json'
            },
            body: JSON.stringify({ is_active }),
        });
        if (!response.ok) throw new Error('Error al actualizar estado del gráfico');
        return await response.json();
    } catch (error) {
        console.error(error);
        throw error;
    }
};

export const updateConsentGraphicName = async (id, name) => {
    try {
        const token = localStorage.getItem('token');
        const response = await fetch(`${API_URL}/api/clinical-records/consent-graphics/${id}/`, {
            method: 'PATCH',
            headers: {
                'Authorization': `Bearer ${token}`,
                'Content-Type': 'application/json'
            },
            body: JSON.stringify({ name }),
        });
        if (!response.ok) throw new Error('Error al actualizar nombre del gráfico');
        return await response.json();
    } catch (error) {
        console.error(error);
        throw error;
    }
};

export const deleteConsentGraphic = async (id) => {
    try {
        const token = localStorage.getItem('token');
        const response = await fetch(`${API_URL}/api/clinical-records/consent-graphics/${id}/`, {
            method: 'DELETE',
            headers: {
                'Authorization': `Bearer ${token}`
            }
        });
        if (!response.ok) throw new Error('Error al eliminar gráfico');
        return true;
    } catch (error) {
        console.error(error);
        throw error;
    }
};

export const getClinicalTerms = async (category = '') => {
    try {
        const token = localStorage.getItem('token');
        const url = category ? `${API_URL}/api/clinical-records/clinical-terms/?category=${category}&limit=1000` : `${API_URL}/api/clinical-records/clinical-terms/?limit=1000`;
        const response = await fetch(url, {
            headers: {
                'Authorization': `Bearer ${token}`
            }
        });
        if (!response.ok) throw new Error('Error al cargar términos clínicos');
        const data = await response.json();
        return data.results !== undefined ? data.results : data;
    } catch (error) {
        console.error(error);
        return [];
    }
};

export const createClinicalTerm = async (data) => {
    try {
        const token = localStorage.getItem('token');
        const response = await fetch(`${API_URL}/api/clinical-records/clinical-terms/`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${token}`
            },
            body: JSON.stringify(data),
        });
        if (!response.ok) throw new Error('Error al crear término clínico');
        return await response.json();
    } catch (error) {
        console.error(error);
        throw error;
    }
};

export const updateClinicalTerm = async (id, data) => {
    try {
        const token = localStorage.getItem('token');
        const response = await fetch(`${API_URL}/api/clinical-records/clinical-terms/${id}/`, {
            method: 'PUT',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${token}`
            },
            body: JSON.stringify(data),
        });
        if (!response.ok) throw new Error('Error al actualizar término clínico');
        return await response.json();
    } catch (error) {
        console.error(error);
        throw error;
    }
};

export const deleteClinicalTerm = async (id) => {
    try {
        const token = localStorage.getItem('token');
        const response = await fetch(`${API_URL}/api/clinical-records/clinical-terms/${id}/`, {
            method: 'DELETE',
            headers: {
                'Authorization': `Bearer ${token}`
            }
        });
        if (!response.ok) throw new Error('Error al eliminar término clínico');
        return true;
    } catch (error) {
        console.error(error);
        throw error;
    }
};
